export default __webpack_public_path__ + "static/media/rs-arte-7.2179c109.webp";